import { FC, useState } from "react";
import {
  CodeCard,
  CodeCardProps,
  JsHtmlRun,
  JsHtmlRunDataSource,
} from "@quark/design";

interface JsHtmlProps extends CodeCardProps {
  code: string;
  language: string;
  runnable: boolean;
  dataSource: JsHtmlRunDataSource;
}

const JsHtml: FC<JsHtmlProps> = ({ code, language, runnable, dataSource }) => {
  const [showCodeRun, setShowCodeRun] = useState(false);

  return (
    <>
      <CodeCard
        code={code}
        language={language}
        runnable={runnable}
        onButtonClick={() => {
          setShowCodeRun(true);
        }}
      />
      <JsHtmlRun
        visible={showCodeRun}
        dataSource={dataSource}
        onClose={() => setShowCodeRun(false)}
      />
    </>
  );
};

export default JsHtml;
